import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class CategoriesQueryService {
    public GET_ALL_CATEGORIES_DATA: any;
    public GET_SUB_CATEGORY_BY_ID_DATA: any;

    constructor(public apollo: Apollo) {

        //Get all schedule bookings
        this.GET_ALL_CATEGORIES_DATA = gql` 
            query getOrderCategories($orderId:Int!){
                allCategories(condition:{orderId:$orderId}) {
                    edges {
                    node {
                        categoryId
                        categoryName
                        subCategoriesByCategoryId {
                        edges {
                            node {
                            subCategoryId
                            categoryId
                            subCategoryName
                            description
                            imgPath
                            }
                        }
                        }
                    }
                    }
                }
            }
     `
            ;
        this.GET_SUB_CATEGORY_BY_ID_DATA = gql` 
        query GetReturnSelectedId($Id:Int, $subId:Int) {
            allSubCategories( condition: {categoryId: $Id, subCategoryId: $subId} ) {
             edges {
               node {
                 categoryId
                 subCategoryId
                 subCategoryName
                 description
                materialCost
                labourCost
                totalCost
                resourceLink
                imgPath
                nodeId
               }
             }
           }
           }
        `;
    }
    GET_ALL_CATEGORIES(currentOrderId) {
        return this.apollo.watchQuery({
            query: this.GET_ALL_CATEGORIES_DATA,
            variables:
            {
                orderId: Number.parseInt(currentOrderId),
            },
            fetchPolicy: 'network-only'
        })
    }
    GET_SUB_CATEGORY_BY_ID(category) {
        return this.apollo.watchQuery({
            query: this.GET_SUB_CATEGORY_BY_ID_DATA,
            variables:
            {
                Id: category.categoryId,
                subId: category.subCategoryId
            },
            fetchPolicy: 'network-only'
        })
    }
    SELECTED_FIELD_CATEGORIES(category) {
        return this.apollo.watchQuery({
            query: this.GET_SUB_CATEGORY_BY_ID_DATA,
            variables:
            {
                Id: category.categoryId,
                subId: category.subCategoryId
            }
        })
    }
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/categories.ts